module.exports = __webpack_public_path__ + "static/media/whatsapp-logo.45c6a02f.png";